import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {IStore} from 'redux/interface';
import {loadTranslation} from 'redux/translation/translationAsyncActions';

interface IUseGetTranslations {
  translationKey: string
}

export const useGetTranslations = ({
  translationKey
}: IUseGetTranslations): void => {
  const {
    translations,
    locale
  } = useSelector((state: IStore) => state.translation);
  const dispatch = useDispatch();

  useEffect(() => {
    // `translationKeys` (the global loaded-key list) only tracks whether this page's
    // messages have EVER been fetched for ANY locale, not for the current one - so a
    // page whose messages loaded once under 'en' would never refetch after switching
    // to 'es'. Check the current locale's own messages instead, matching the (correct)
    // per-locale check changeLocale() already uses.
    const alreadyLoadedForLocale = Object.keys(translations[locale] || {})
      .some((key: string): boolean => key.includes(translationKey));

    if (!alreadyLoadedForLocale) {
      dispatch(loadTranslation(translationKey));
    }
  }, [locale]);
};
